import React, { useState } from 'react';
import styles from './ProductForm.module.css';

const initialState = {
  name: '',
  price: '',
  description: '',
  category: '',
  image: ''
};

const ProductForm = ({ onAddProduct }) => {
  const [form, setForm] = useState(initialState);
  const [imagePreview, setImagePreview] = useState(null);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'image' && files && files[0]) {
      setForm({ ...form, image: files[0] });
      setImagePreview(URL.createObjectURL(files[0]));
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name || !form.price || !form.description || !form.category) return;
    onAddProduct(form, imagePreview);
    setForm(initialState);
    setImagePreview(null);
    e.target.reset();
  };

  return (
    <form className={styles.productForm} onSubmit={handleSubmit}>
      <h2 className={styles.formTitle}>Add New Product</h2>
      <div className={styles.formGroup}>
        <label>Product Name</label>
        <input type="text" name="name" value={form.name} onChange={handleChange} required />
      </div>
      <div className={styles.formGroup}>
        <label>Price (₹)</label>
        <input type="number" name="price" value={form.price} onChange={handleChange} required min="1" />
      </div>
      <div className={styles.formGroup}>
        <label>Description</label>
        <textarea name="description" value={form.description} onChange={handleChange} required rows={2} />
      </div>
      <div className={styles.formGroup}>
        <label>Category</label>
        <select name="category" value={form.category} onChange={handleChange} required>
          <option value="">Select Category</option>
          <option value="Crochet">Crochet</option>
          <option value="Knitting">Knitting</option>
          <option value="Embroidery">Embroidery</option>
          <option value="Other">Other</option>
        </select>
      </div>
      <div className={styles.formGroup}>
        <label>Image</label>
        <input type="file" name="image" accept="image/*" onChange={handleChange} />
        {imagePreview && <img src={imagePreview} alt="Preview" className={styles.imagePreview} />}
      </div>
      <button className={styles.addBtn} type="submit">Add Product</button>
    </form>
  );
};

export default ProductForm;
